var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuseum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 5.5H3.5V18.5H20.5V5.5ZM2 4V20H22V4H2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.614 10.75H9.664V14.5H8.614V10.75ZM8.041 14.708H15.958V15.125H16.58V15.75H16.997V16.167H7V15.75H7.417V15.125H8.042L8.041 14.708ZM16.38 9.66899L12 7.83299L7.625 9.66899V9.91599H16.38V9.66899ZM8.463 10.125H15.542V10.542H8.458L8.463 10.125ZM14.34 10.75H15.387V14.5H14.336L14.34 10.75ZM12.433 10.75H13.48V14.5H12.429L12.433 10.75ZM10.526 10.75H11.576V14.5H10.521L10.526 10.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.ff0f8cfb5b8d5d03bc8c089689bf1656.svg";
export { ForwardRef as ReactComponent };